/**
 * Monto mínimo en COP para pedido o tramo con método Bold.
 * Debe coincidir con la regla de la API Bold (p. ej. PL_001).
 */
export const BOLD_ORDER_MIN_AMOUNT_COP = 1000

/** Monto máximo en COP para pedido con método Bold (pago total). */
export const BOLD_ORDER_MAX_AMOUNT_COP = 10_000_000

/** @deprecated Usar BOLD_ORDER_MIN_AMOUNT_COP */
export const BOLD_PARTIAL_MIN_AMOUNT_COP = BOLD_ORDER_MIN_AMOUNT_COP

const BOLD_AMOUNT_ERROR_PREFIX = 'Bold:'

export function formatBoldAmountCop(value: number): string {
  return `$${value.toLocaleString('es-CO')} COP`
}

/** Mensaje de error si el total no está en rango Bold; null si es válido. */
export function getBoldOrderAmountValidationError(totalCop: number): string | null {
  const total = Math.round(Number(totalCop) || 0)
  if (total < BOLD_ORDER_MIN_AMOUNT_COP) {
    return `${BOLD_AMOUNT_ERROR_PREFIX} el total debe ser mínimo ${formatBoldAmountCop(BOLD_ORDER_MIN_AMOUNT_COP)}`
  }
  if (total > BOLD_ORDER_MAX_AMOUNT_COP) {
    return `${BOLD_AMOUNT_ERROR_PREFIX} el total no puede superar ${formatBoldAmountCop(BOLD_ORDER_MAX_AMOUNT_COP)}`
  }
  return null
}

export function isBoldOrderAmountValid(totalCop: number): boolean {
  return getBoldOrderAmountValidationError(totalCop) === null
}

export function isBoldAmountRangeErrorMessage(message: string | undefined): boolean {
  return Boolean(message?.startsWith(BOLD_AMOUNT_ERROR_PREFIX))
}
